import { useEffect } from "react";
import "@n8n/chat/dist/style.css";
import { createChat } from "@n8n/chat";
export default function Chat() {
    useEffect(() => {
        createChat({
            webhookUrl: "https://n8n.pbltransport.cloud/webhook/3652ed30-5283-4fdf-bf54-165d56492e3d/chat",
            mode: "window",
            title: "Ask Me Anything!",
            defaultLanguage: 'en',
            initialMessages: [
                "Hello! I’m PaBLo, your friendly assistant at PBL Transport Corporation.",
                "I can help you learn anything about our company — our fleet, services, projects, and more.",
                "If you’d like someone from our team to contact you, just let me know.",
            ],
            theme: {
                primaryColor: "#085d6b",
            },
            i18n: {
                en: {
                    title: '',
                    subtitle: "",
                    footer: '',
                    getStarted: 'New Conversation',
                    inputPlaceholder: 'Type your question..',
                },
            },
        });
    }, []);
    return null;
}
